<template>
  <div class="row">
    <file-picker
      ref="filePickerFastEdit"
      class="ui-w-52 ui-mr-2"
      label="Escolher arquivo"
      small
      @change="uploadCSV"
    />
    <c-button
      size="sm"
      class="ui-mx-2"
      @click="genBaseCSV"
    >
      Acessar CSV base
    </c-button>
    <c-button
      v-if="metabaseLink"
      size="sm"
      class="ui-mx-2"
      @click="openMetabase"
    >
      Link metabase
    </c-button>
    <c-button
      size="sm"
      class="ui-mx-2"
      @click="submitCSV"
    >
      Enviar
    </c-button>
  </div>
</template>

<script>
import { CButton } from '@estrategiahq/coruja-web-ui';
import FilePicker from '../FilePicker';

export default {
  name: 'FastBatchEdit',
  components: {
    FilePicker,
    CButton,
  },
  props: {
    metabaseLink: {
      type: String,
      default: null,
    },
    submitFunction: {
      type: Function,
      required: true,
    },
    baseEntity: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
  }),
  methods: {
    openMetabase() {
      window.open(this.metabaseLink, '_blank');
    },
    genBaseCSV() {
      const anchor = document.createElement('a');
      anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(this.baseEntity.join(','))}`;
      anchor.target = '_blank';
      anchor.download = 'arquivo_base.csv';
      anchor.click();
    },
    async uploadCSV(file) {
      try {
        if (!file) throw new Error('Nenhum arquivo fornecido.');

        const textFile = await file.text();
        if (!textFile.trim()) throw new Error('O arquivo está vazio.');

        const lines = textFile.split('\n').map(line => line.replace(/\r$/, ''));

        const hasData = lines.slice(1).some(line => line.trim().length > 0);

        if (!hasData) {
          this.$q.notify({
            message: 'O arquivo CSV contém apenas a linha de cabeçalho, sem dados para processar.',
            color: 'warning',
          });
          return;
        }

        this.payload = lines;
      } catch (error) {
        this.$q.notify({
          message: `Erro ao carregar o arquivo: ${error.message}`,
          color: 'negative',
        });
      }
    },
    async submitCSV() {
      try {
        await this.submitFunction(this.payload);
        this.$q.notify({
          message: 'Atualização em massa enviada para processamento! Em breve você vai receber o resultado por email!',
          color: 'positive',
        });
      } catch (_) {
        this.$q.notify({
          message: 'Falha ao fazer atualização em massa',
          color: 'negative',
        });
      }
    },
  },
};
</script>

<style>
</style>
